// extracted by mini-css-extract-plugin
export default {"errorScreen":"AppBoot__errorScreen___YHtCq","reloadButton":"AppBoot__reloadButton___ezsMx"};